import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import Snackbar from 'material-ui/Snackbar';
var Notifications = /** @class */ (function (_super) {
    tslib_1.__extends(Notifications, _super);
    function Notifications(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            active: false,
            message: ''
        };
        _this.startNotify = function () {
            _this.setState({
                active: true,
                message: _this.props.userStore.notification
            });
        };
        _this.endNotify = function () {
            _this.setState({
                active: false,
                message: ''
            });
        };
        return _this;
    }
    Notifications.prototype.componentWillMount = function () {
        this.props.userStore.startNotify.subscribe(this.startNotify);
        this.props.userStore.endNotify.subscribe(this.endNotify);
    };
    Notifications.prototype.componentWillUnMount = function () {
        this.props.userStore.startNotify.unsubscribe(this.startNotify);
        this.props.userStore.endNotify.unsubscribe(this.endNotify);
    };
    Notifications.prototype.render = function () {
        return React.createElement(Snackbar, { open: this.state.active, message: this.state.message });
    };
    Notifications = tslib_1.__decorate([
        inject('userStore'),
        observer
    ], Notifications);
    return Notifications;
}(React.Component));
export { Notifications };



//////////////////
// WEBPACK FOOTER
// ./src/layout/Notifications.tsx
// module id = 819
// module chunks = 0